import React from "react";
import { Spinner } from "react-bootstrap";
import { Pie } from "react-chartjs-2";
import "chart.js/auto";
interface TransactionsBarChartProp {
  successTransactions?: number;
  totalRecords?: number;
  isLoading: boolean;
  terminalId?: number | string;
}
export const TransactionsBarChart: React.FC<TransactionsBarChartProp> = ({
  successTransactions = 0,
  totalRecords = 0,
  isLoading,
  terminalId = "نامشخص",
}) => {
  const data = {
    labels: ["تعداد تراکنش های موفق", "تعداد تراکنش های ناموفق"],
    datasets: [
      {
        data:
          totalRecords !== 0
            ? [successTransactions, totalRecords - successTransactions]
            : [0, 0, 0.001],
        backgroundColor: ["#26D980", "#e71227"],
        hoverOffset: 4,
      },
    ],
  };

  return (
    <div className="custom-box h-100 d-flex gap-1"> 
      <div className="d-flex flex-grow-1 flex-column py-4 px-1 ">
        <p className="d-flex justify-content-between align-items-center">
          <span  >
            <label
              style={{
                height: "10px",
                width: "10px",
                borderRadius: "10px",
                backgroundColor: "#26D980",
              }}
            ></label>
            &nbsp; تعداد تراکنش های موفق :
          </span>
          <h2 className="m-0"> {successTransactions}</h2>
        </p>
        <hr className={"mt-0"} />
        <p className="d-flex justify-content-between align-items-center">
          <span>
            <label
              style={{
                height: "10px",
                width: "10px",
                borderRadius: "10px",
                backgroundColor: "#e71227",
              }}
            ></label>
            &nbsp; تعداد تراکنش های ناموفق :
          </span>
          <h2 className="m-0"> {totalRecords - successTransactions}</h2>
        </p>
        <hr className={"mt-0"} />
        <p className="d-flex justify-content-between">
        <span>
            <label
              style={{
                height: "10px",
                width: "10px",
                borderRadius: "10px",
                backgroundColor: "#1555fb",
              }}
            ></label>
            &nbsp; تعداد همه تراکنش ها :
          </span>
          <h2 className="m-0"> {totalRecords}</h2>
        </p>
      </div>
      <Pie
        data={data}
        options={{
          animation: {
            duration: 0,
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: function (context) {
                  const label = context.label || "";
                  const value = context.parsed || 0;
                  if (value === 0.001) {
                    return [
                      "تعداد کل تراکنش ها: 0 ",
                      "تعداد تراکنش های موفق: 0 ",
                    ];
                  } else {
                    return label + ": " + value;
                  }
                },
              },

              titleFont: {
                size: 12,
                family: "shabnam",
              },
              bodyFont: {
                size: 12,
                family: "shabnam",
              },
            },
            legend: {
              display: false,
              labels: {
                font: {
                  family: "shabnam",
                  size: 12,
                  weight: "bold",
                },
              },
            },
            title: {
              display: false,
            },
          },
        }}
      />
    </div>
  );
};
